import { OutlookService } from "../service/outlook/outlook.service";
import { isIEOrEdge } from "./soAuthenticatorUtils";
import { Inject, Injectable } from "@angular/core";
@Injectable({
  providedIn: "root",
})
export class SoLoginDialog {

  constructor(private readonly outlookService: OutlookService) { }

  /**
   * same key as used in original office-js-helpers package:
   * https://github.com/OfficeDev/office-js-helpers/blob/master/dialog.ts#L66
   * honestly not sure if key value is signficant or not :D
   */
  private static readonly key = "VGVtcG9yYXJ5S2V5Rm9yT0pIQXV0aA==";

  /**
   * Close any open dialog by providing an optional message.
   * If more than one dialogs are attempted to be opened
   * an exception will be created.
   *
   * Copy-paste, adapted and minimized based on
   * https://github.com/OfficeDev/office-js-helpers/blob/master/dialog.ts#L166-L204
   */
  close(value?: string): void {
    if (this.outlookService.isAddin) {
      if (this.outlookService.ui.messageParent) {
        this.outlookService.ui.messageParent(value);
      }
    } else {
      if (isIEOrEdge()) {
        localStorage.setItem(SoLoginDialog.key, value);
      } else if (window.opener) {
        window.opener.postMessage(value, location.origin);
      }
      window.close();
    }
  }

  async getUrlWithCode(url: string): Promise<string> {
    return this.showDialogue(url);
  }

  async showDialogue(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.outlookService.openDialog(url, 1024, 768,
        (message) => resolve(message),
        (error) => reject(error)
      );
    });
  }
}
